(() => {
  "use strict";

  const VERSION = "18.0-measured-sitewide";
  const CASE_WIDTH_AT_40_MM = 0.45;
  const calibrationRows = [
    ["33261copy.jpg","1644400738339",34,2841,3217,0.71375,0.480625,0.4966887,true],
    ["34-2730-icopy.jpg","1644403884067",34,931,1011,0.6625,0.495,0.4971231,true],
    ["09-2495-icopy_f076fc0a-1dfb-4ac2-8cc1-d8f6904b6c23.jpg","1645380436003",34,897,973,0.64375,0.470625,0.4735023,true],
    ["22-2731-icopy.jpg","1645396983843",31,993,1085,0.57875,0.500625,0.4965675,true],
    ["565314270a182704fronteditedcopy.png","1649251024931",36,1080,1525,0.9275,0.46625,0.4769912,true],
    ["6388copy.png","6070787276989",40,1699,1817,0.79125,0.474375,0.4953271,true],
    ["0870tempvs25032116027-compcopy_981be5ec-aee6-48c8-93b7-1d74652a7433.jpg","6666840867005",36,2908,3573,0.76375,0.491875,0.4872838,true],
    ["376816610k857142copy.png","7063119200445",40,2128,2231,0.83375,0.459375,0.5053635,true],
    ["6728114270z516980fronteditedcopy2.png","7077579260093",36,3000,3886,0.88,0.4425,0.4720077,true],
    ["375716800servicecardfrontcopy.png","7077724389565",40,2951,3305,0.875,0.43875,0.4810268,true],
    ["114270-f288516fronteditedcopy.png","7088414720189",36,3000,4231,0.935,0.47,0.4955674,true],
    ["6756168000r598527fronteditedcopy.png","7211338399933",40,2994,3165,0.795,0.445,0.4763593,true],
    ["694316570a597619fronteditedcopy.png","7211823792317",40,2477,2733,0.8175,0.48,0.4801812,true],
    ["16600u891106fronteditedcopy.png","7431574782141",40,1282,1519,0.9175,0.45875,0.4746835,true],
    ["91-3196-icopy.jpg","7491674013885",40,1306,1417,0.81375,0.475625,0.4976959,true],
    ["tempvs-16622-40mm-proportional_ab558d49-bf9c-4c67-9044-390c1341d6e2.png","15994894385536",40,1600,2048,0.68,0.46875,0.4863281,true],
    ["tempvs-15200-34mm-proportional_6a04eea9-0d39-4fc5-bad8-e62ffa5ae753.png","15994895270272",34,1600,2048,0.58625,0.478125,0.453125,true],
    ["tempvs-126621-40mm-proportional_791bca0c-73e7-4c73-986f-15420b5bdd60.png","15994895729024",40,1600,2048,0.68,0.46875,0.4306641,true],
    ["tempvs-126301-41mm-proportional_e0dde02c-7e17-420f-bc9d-2cde9f941cc5.png","15994895958400",41,1600,2048,0.7125,0.47625,0.4326172,true],
    ["tempvs-126300-41mm-proportional_cf372a96-5e96-45f9-bc14-65b713b906b6.png","15994896286080",41,1600,2048,0.7125,0.47625,0.4091797,true],
    ["tempvs-al8-proportional-final_eee073c7-fcc4-4760-b34a-f6e848de44de.png","15994896646528",41,1600,2048,0.61875,0.500625,0.5097656,true],
    ["tempvs-126331-41mm-proportional_fc158ded-2391-41d4-aad3-33f2034ca15f.png","15994896843136",41,1600,2048,0.7125,0.47625,0.4248047,true],
    ["126231-hz4-front.png","15994897072512",36,1195,2048,0.75625,0.480625,0.3916849,true],
    ["tempvs-116333-41mm-proportional_1e7ecbc1-2ea6-4cf4-83e0-7116bab9efb1.png","15994897269120",41,1600,2048,0.7125,0.47625,0.4785156,true],
    ["tempvs-268622-37mm-proportional_42aa6ed5-b2a1-4883-a632-8766fa30ee12.png","15994897400192",37,1600,2048,0.62875,0.470625,0.4765625,true],
    ["tempvs-116710blnr-40mm-proportional_0f07d46d-103e-4364-855c-2e6e41166bde.png","15994897498496",40,1600,2048,0.67875,0.468125,0.5048828,true],
    ["tempvs-126710blro-40mm-proportional_26156e78-af1f-4885-9175-d38c40ba5e52.png","15994897957248",40,1600,2048,0.67875,0.468125,0.4814453,true],
    ["tempvs-a133711-48mm-proportional_77e57fca-c798-4b2f-b43f-1e9dfcbfce6b.png","15994898121088",48,1600,2048,0.80125,0.454375,0.4785156,true],
    ["tempvs-i85-proportional-final_5767da1a-3dd6-44c3-96d6-d0eb01b47ef8.png","15994898284928",42,1600,2048,0.6175,0.50625,0.4931641,true],
    ["tempvs-25995ip-42mm-proportional_87ea600c-8cf9-4e45-af74-0ff3781a5789.png","15994898416000",42,1600,2048,0.7,0.46,0.5029297,true],
    ["tempvs-fm-magnum-34mm-front_87a4f905-ee59-41b0-a02a-e0f9eb49dbbc.png","16007602307456",34,1600,2048,0.505,0.50125,0.5097656,true],
    ["tempvs-fm-vanguard-44mm-front.png","16007602405760",44,1600,2048,0.6725,0.5,0.5078125,true],
    ["tempvs-6017-19mm-front.png","16007602438528",19,1600,2048,0.29375,0.504375,0.5078125,true],
    ["tempvs-9973-32mm-front.png","16007602536832",32,1600,2048,0.48375,0.503125,0.5097656,true],
    ["tempvs-ap-cambre-23mm-final.png","16007602831744",23,1600,2048,0.34875,0.499375,0.5019531,true],
    ["tempvs-88340-proportional-final.png","16007603159424",36,1600,2048,0.545,0.505,0.4980469,true],
    ["tempvs-d916-proportional-final.png","16007603224960",39,1600,2048,0.59375,0.508125,0.5097656,true],
    ["tempvs-8218-proportional-final.png","16007603323264",25,1600,2048,0.37875,0.500625,0.5107422,true],
    ["tempvs-9062-proportional-final.png","16007603519872",40,1600,2048,0.60375,0.501875,0.5078125,true],
    ["tempvs-p191-proportional-final.png","16007603618176",29,1600,2048,0.43625,0.500625,0.4990234,true],
    ["5499_01_0.jpg","1644376817699",null,2500,3540,0.585,0.5,0.50661959,false],
    ["w2633201copy.jpg","1644401492003",36.0,2565,2681,0.65,0.48875,0.49401914,true],
    ["02-1930-icopy.jpg","1645442793507",31.0,984,1016,0.5775,0.48375,0.50242131,true],
    ["10-3315-icopy.jpg","1722257604643",36.0,1153,1327,0.7025,0.455,0.48859935,true],
    ["5471icopy.jpg","1731789127715",36.0,1168,1367,0.7975,0.475,0.49145299,true],
    ["rolex_datejust_126200_i.jpg","1806902755363",null,1252,2040,0.8325,0.48625,0.49539877,false],
    ["screenshot2020-09-25at13.23.51118copy.png","4704970375238",41.0,990,1144,0.8725,0.4625,0.49350649,true],
    ["6359116233champicopy_5ea9089a-3e09-4f89-9432-1d0689c1ca28.jpg","6102747676861",36.0,1600,1831,0.7625,0.48125,0.48144105,true],
    ["6290icopy.jpg","6218330898621",26.0,1536,1862,0.595,0.47125,0.4628866,true],
    ["16thmarch20207copy.jpg","6226413912253",26.0,1046,1145,0.5375,0.48125,0.47146119,true],
    ["0873tempvs0804210107-comp.jpg","6690813903037",26.0,3000,4201,0.6375,0.5025,0.47321429,true],
    ["6644m3093000884tempvs1905211829-compcopy.jpg","6789022646461",40.0,3000,3140,0.795,0.4825,0.48506571,true],
    ["5709frontedited1copy.png","7019683676349",36.0,2000,2290,0.8225,0.455,0.49235808,true],
    ["m670238-1copy.jpg","7063169401021",36.0,2329,2640,0.795,0.465,0.5016538,true],
    ["678914270swissfrontcopy.png","7107351609533",36.0,1975,2116,0.7125,0.4825,0.48891482,true],
    ["6866panna116520frontcopy.png","7182895251645",40.0,2521,2685,0.8225,0.45625,0.49413146,true],
    ["16700u813239frontcopy.png","7195768586429",40.0,1714,1875,0.81,0.47875,0.48342857,true],
    ["6751m16570u291384fronteditedcopy_d5158aec-67d8-4cc3-9d2c-09c04fbe0827.png","7207978860733",40.0,2894,3069,0.785,0.4775,0.47995283,true],
    ["378536470866tempvs16032114398-compcopy.jpg","7207999733949",40.0,3750,3958,0.8325,0.475,0.47511848,true],
    ["483355131174733fronteditedcopy.png","7208796717245",40.0,1500,1577,0.7625,0.46125,0.48156956,true],
    ["aprosechronofronteditedcopy.png","7209710911677",41.0,3000,3378,0.845,0.425,0.49278579,true],
    ["6823116200z450737fronteditedcopy.png","7211335286973",36.0,3000,3369,0.745,0.4675,0.49109131,true],
    ["rmnadalfrontedited1copy.png","7215560884413",42.0,2820,2857,0.82,0.46375,0.4962963,true],
    ["116300317w4987editedcopy.png","7226897694909",41.0,2803,2954,0.855,0.47875,0.49466192,true],
    ["116710lnm744281fronteditedcopy.png","7251042533565",40.0,2852,3094,0.83,0.4675,0.4781106,true],
    ["16613blackz391139_f493019editedcopy_frontcopy.png","7257681002685",40.0,2000,2077,0.83,0.45625,0.47894103,true],
    ["17332008_1copy.jpg","7258199163069",42.0,858,885,0.79,0.48125,0.47636364,true],
    ["m326934-0004copy.png","7267941155005",42.0,930,968,0.8125,0.46625,0.4729892,true],
    ["1163345h760186fronteditedcopy.png","7271180665021",41.0,2922,3097,0.84,0.475,0.48349057,true],
    ["50996609thunderbirdfrontcopy.png","7279358640317",36.0,1933,2053,0.6525,0.4725,0.48705882,true],
    ["rolex-114060-submariner_1024x_035c301e-1952-431a-9a8a-693bddcab963.png","7437537902781",40.0,591,611,0.81218274,0.45685279,0.46808511,true],
    ["116613lng838761fronteditedcopy.png","7463661371581",40.0,2883,3088,0.8325,0.475,0.47957993,true],
    ["124300543lk191fronteditedcopy.png","7466297327805",41.0,2754,2984,0.8175,0.4675,0.48788927,true],
    ["12620067k642c2fronteditedcopy.png","7466297491645",36.0,3000,3335,0.7875,0.47875,0.4791901,true],
    ["1263004995c4a8fronteditedcopy.png","7466740809917",41.0,2847,2960,0.8375,0.485,0.48317308,true],
    ["apj85562editedfrontcopy.png","7470046380221",41.0,2767,2660,0.8,0.45625,0.50195059,true],
    ["bvlgarifissimobu2igecfrontcopy.png","7475676512445",40.0,3000,3319,0.8325,0.48125,0.48926554,true],
    ["7101287274l91801j3fronteditedcopy.png","7477100544189",31.0,3000,3478,0.78,0.4725,0.47788565,true],
    ["25600tn44z8479frontcopy.png","7477805973693",42.0,3000,3257,0.8375,0.4675,0.4867664,true],
    ["omega310384334719frontcopy.png","7483960459453",42.0,2957,3015,0.81,0.475,0.46323529,true],
    ["7132bvlgariserpentisrfrontcopy.png","7483960688829",35.0,2827,2724,0.5325,0.6,0.43579767,false],
    ["6536giltcopy.png","7490205843645",37.0,2977,3305,0.78,0.4675,0.46396396,true],
    ["14060a556735front1copy.png","7490789015741",40.0,1347,1471,0.81,0.46375,0.46796339,true],
    ["379879010sg74en504frontcopy.png","7491499229373",39.0,2988,3174,0.765,0.47,0.46352941,true],
    ["tudor-m70330b-0004_14499157-adf3-4c9f-bdbb-5e5384ed0d2e.png","7493448302781",42.0,702,761,0.7977208,0.46866097,0.49934297,true],
    ["116660v422930frontcopy.png","7566159773885",44.0,1380,1403,0.825,0.4625,0.4501845,true],
    ["bvlgari5038front1copy.png","7628478087357",33.0,1729,2450,0.77,0.4575,0.46031746,true],
    ["116264d654888frontcopy.png","7628478513341",36.0,1879,2162,0.795,0.48375,0.47826087,true],
    ["116264d205326frontcopy.png","7631769436349",36.0,1963,2140,0.7425,0.4725,0.47591743,true],
    ["v847205frontcroppedcopy.png","7632985882813",26.0,2577,3034,0.685,0.47,0.46178344,true]
  ];
  const calibrations = new Map(calibrationRows.map(([
    filename, productId, mm, sourceWidth, sourceHeight, caseFraction, centreX, centreY, verified
  ]) => [filename, { productId, mm, sourceWidth, sourceHeight, caseFraction, centreX, centreY, verified }]));
  const SELECTOR = [
    ".ProductItem__ImageWrapper[data-tempvs-watch-card] > .AspectRatio > img.ProductItem__Image:not(.ProductItem__Image--alternate)",
    ".TempvsWatchProduct .Product__SlideItem--image > .AspectRatio > img",
    ".TempvsWatchProduct .Product__SlideshowNavImage > img",
    ".TempvsSearchImage > img",
    ".CartItem__ImageWrapper > .AspectRatio > img.CartItem__Image"
  ].join(",");
  const states = new Map();
  const variables = ["--tempvs-image-width", "--tempvs-image-height", "--tempvs-image-left", "--tempvs-image-top"];
  let resizeObserver;
  let scheduled = false;

  function attribute(element, name, value) {
    if (!element) return;
    if (value === null || value === undefined) {
      if (element.hasAttribute(name)) element.removeAttribute(name);
    } else if (element.getAttribute(name) !== String(value)) {
      element.setAttribute(name, String(value));
    }
  }

  function parseMillimetres(value) {
    const match = String(value || "").match(/^\s*(\d{1,2}(?:\.\d+)?)\s*(?:mm)?\s*$/i);
    if (!match) return null;
    const mm = Number(match[1]);
    return Number.isFinite(mm) && mm >= 15 && mm <= 70 ? mm : null;
  }

  function sourceInfo(source) {
    if (!source) return null;
    try {
      const url = new URL(source, location.href);
      if (url.protocol !== "http:" && url.protocol !== "https:") return null;
      const filename = decodeURIComponent(url.pathname.split("/").pop() || "").toLowerCase();
      const cropped = url.searchParams.has("crop") || /_crop_[a-z]+(?:@[23]x)?\.[a-z0-9]+$/i.test(filename);
      if (calibrations.has(filename)) return { source, filename, cropped, record: calibrations.get(filename) };
      const original = filename
        .replace(/_\{width\}x(?=\.[a-z0-9]+$)/i, "")
        .replace(/_(?:\d+x\d*|x\d+)(?:_crop_[a-z]+)?(?:@[23]x)?(?=\.[a-z0-9]+$)/i, "");
      return { source, filename: original, cropped, record: calibrations.get(original) || null };
    } catch {
      return null;
    }
  }

  function findCalibration(image) {
    const loaded = sourceInfo(image.currentSrc || image.getAttribute("src"));
    if (loaded) return loaded;
    return sourceInfo(image.getAttribute("data-src")) || sourceInfo(image.getAttribute("data-original-src"));
  }

  function contextFor(image) {
    const slot = image.parentElement;
    if (!slot) return null;
    const card = image.closest(".ProductItem__ImageWrapper[data-tempvs-watch-card]");
    if (card) return { slot, owner: card, kind: "card" };
    const cart = image.closest(".CartItem__ImageWrapper");
    if (cart) return { slot, owner: cart, kind: "cart" };
    if (slot.classList.contains("TempvsSearchImage")) return { slot, owner: slot, kind: "search" };
    const product = image.closest(".TempvsWatchProduct");
    if (product) return { slot, owner: product, kind: slot.classList.contains("Product__SlideshowNavImage") ? "thumbnail" : "gallery" };
    return null;
  }

  function measureLayout(record, mm, frameWidth, frameHeight, imageWidth, imageHeight) {
    const casePixels = Math.min(frameWidth, frameHeight) * CASE_WIDTH_AT_40_MM * mm / 40;
    const width = casePixels / record.caseFraction;
    const height = width * imageHeight / imageWidth;
    return {
      casePixels,
      width,
      height,
      left: frameWidth / 2 - width * record.centreX,
      top: frameHeight / 2 - height * record.centreY
    };
  }

  function original(state, status) {
    const { image, context } = state;
    attribute(image, "data-tempvs-size-state", "original");
    attribute(image, "data-tempvs-sizing-status", status);
    attribute(image, "data-tempvs-sizing-version", VERSION);
    attribute(image, "data-tempvs-sizing-method", null);
    attribute(image, "data-tempvs-case-px", null);
    attribute(image, "data-tempvs-scale-mm", null);
    attribute(context.slot, "data-tempvs-sizing-slot", null);
    if (context.kind === "card" || context.kind === "cart") {
      attribute(context.owner, "data-tempvs-calibrated", "false");
      attribute(context.owner, "data-tempvs-sizing-accuracy", status);
    }
    for (const variable of variables) {
      if (image.style.getPropertyValue(variable)) image.style.removeProperty(variable);
    }
    state.layoutKey = "";
  }

  function update(state) {
    const { image, context } = state;
    if (!image.isConnected || !context.slot.isConnected) return;
    const match = findCalibration(image);
    const record = match && match.record;
    if (context.kind === "cart") {
      const isWatch = Boolean(record || context.owner.hasAttribute("data-tempvs-watch-card-context"));
      attribute(context.owner, "data-tempvs-sizing-context", isWatch ? "watch" : null);
    }
    if (!record) {
      original(state, context.kind === "gallery" || context.kind === "thumbnail" ? "detail-photo-original" : "needs-image-calibration");
      return;
    }
    if (!record.verified) {
      original(state, record.mm === null ? "needs-case-diameter" : "needs-case-measurement");
      return;
    }
    const diameterElement = image.closest("[data-tempvs-case-mm]");
    const recordedDiameter = diameterElement ? parseMillimetres(diameterElement.getAttribute("data-tempvs-case-mm")) : null;
    const mm = recordedDiameter === null ? parseMillimetres(record.mm) : recordedDiameter;
    if (mm === null) {
      original(state, "needs-case-diameter");
      return;
    }
    if (match.cropped) {
      original(state, "cropped-derivative-original");
      return;
    }
    if (!image.complete || image.naturalWidth < 2 || image.naturalHeight < 2) {
      original(state, "awaiting-native-image");
      return;
    }
    const aspectRatio = image.naturalWidth / image.naturalHeight;
    if (Math.abs(aspectRatio / (record.sourceWidth / record.sourceHeight) - 1) > 0.015) {
      original(state, "source-aspect-changed-needs-review");
      return;
    }
    attribute(context.slot, "data-tempvs-sizing-slot", "measured");
    const frameWidth = context.slot.clientWidth;
    const frameHeight = context.slot.clientHeight;
    if (frameWidth < 1 || frameHeight < 1) return;
    const layout = measureLayout(record, mm, frameWidth, frameHeight, image.naturalWidth, image.naturalHeight);
    const layoutKey = [match.filename, mm, frameWidth, frameHeight, image.naturalWidth, image.naturalHeight].join("|");
    if (layoutKey !== state.layoutKey) {
      const values = [layout.width, layout.height, layout.left, layout.top];
      variables.forEach((variable, index) => image.style.setProperty(variable, `${values[index].toFixed(4)}px`));
      state.layoutKey = layoutKey;
    }
    attribute(image, "data-tempvs-size-state", "measured");
    attribute(image, "data-tempvs-sizing-status", "measured-case-width");
    attribute(image, "data-tempvs-sizing-version", VERSION);
    attribute(image, "data-tempvs-sizing-method", "manual-case-outline");
    attribute(image, "data-tempvs-case-px", layout.casePixels.toFixed(3));
    attribute(image, "data-tempvs-scale-mm", mm);
    if (context.kind === "card" || context.kind === "cart") {
      attribute(context.owner, "data-tempvs-calibrated", "true");
      attribute(context.owner, "data-tempvs-sizing-accuracy", "measured-case-width");
    }
  }

  function scan() {
    scheduled = false;
    for (const [image, state] of states) {
      if (!image.isConnected || !image.matches(SELECTOR)) {
        if (resizeObserver) resizeObserver.unobserve(state.context.slot);
        image.removeEventListener("load", state.onLoad);
        image.removeEventListener("error", state.onError);
        states.delete(image);
      }
    }
    document.querySelectorAll(SELECTOR).forEach(image => {
      const context = contextFor(image);
      if (!context) return;
      let state = states.get(image);
      if (!state) {
        state = { image, context, layoutKey: "", onLoad: schedule, onError: schedule };
        states.set(image, state);
        image.addEventListener("load", state.onLoad);
        image.addEventListener("error", state.onError);
        if (resizeObserver) resizeObserver.observe(context.slot);
      } else if (state.context.slot !== context.slot || state.context.owner !== context.owner) {
        if (resizeObserver) resizeObserver.unobserve(state.context.slot);
        state.context = context;
        state.layoutKey = "";
        if (resizeObserver) resizeObserver.observe(context.slot);
      }
      update(state);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  }

  function boot() {
    if ("ResizeObserver" in window) resizeObserver = new ResizeObserver(schedule);
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["src", "srcset", "data-src", "data-original-src", "data-tempvs-case-mm", "class"]
    });
    window.addEventListener("resize", schedule, { passive: true });
    window.addEventListener("pageshow", schedule);
    document.addEventListener("shopify:section:load", schedule);
    schedule();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot, { once: true });
  else boot();
})();
